/**
 * PoppinPay API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import CardResultModel from './CardResultModel';

/**
* The SaveCardResultModel model module.
* @module model/SaveCardResultModel
* @version 1.0.0
*/
export default class SaveCardResultModel {
    /**
    * Constructs a new <code>SaveCardResultModel</code>.
    * @alias module:model/SaveCardResultModel
    * @class
    */

    constructor() {
        
        
        
    }

    /**
    * Constructs a <code>SaveCardResultModel</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/SaveCardResultModel} obj Optional instance to populate.
    * @return {module:model/SaveCardResultModel} The populated <code>SaveCardResultModel</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SaveCardResultModel();
                        
            
            if (data.hasOwnProperty('Id')) {
                obj['Id'] = ApiClient.convertToType(data['Id'], 'String');
            }
            if (data.hasOwnProperty('Card')) {
                obj['Card'] = CardResultModel.constructFromObject(data['Card']);
            }
        }
        return obj;
    }

    /**
    * @member {String} Id
    */
    'Id' = undefined;
    /**
    * @member {module:model/CardResultModel} Card
    */
    'Card' = undefined;




}
